// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","571":"settings"}[chunkId] + "." + {"177":"f45de180","571":"9c1ec13a"}[chunkId] + ".js";
};